document.addEventListener('DOMContentLoaded', () => {

    const wrappers = document.querySelectorAll('.multicolumn-card__image-wrapper');

    wrappers.forEach(container => {
        const image = container.querySelector('.multicolumn-card__image');
      
        container.addEventListener('mousemove', (e) => {
            const rect = container.getBoundingClientRect();
            const x = e.clientX - rect.left; // Mouse position relative to the container
            const y = e.clientY - rect.top; // Mouse position relative to the container

            const xPercent = (x / rect.width) * 100; // Convert to percentage
            const yPercent = (y / rect.height) * 100; // Convert to percentage

            image.style.transformOrigin = `${xPercent}% ${yPercent}%`;
        });

        container.addEventListener('mouseleave', () => {
            image.style.transformOrigin = 'center center'; // Reset origin when mouse leaves
        });
    });
});